module.exports = __webpack_public_path__ + "img/cerrses-icon-claro.dd4b9f70.svg";